import config from 'config/shared';
import { logError } from './logger';
import { isSSR } from 'utils/isSSR';

async function imageCdnReadiness() {
	if (!config.imageCdnManifest || !config.imageCdnUrl) {
		return false;
	}

	if (!isSSR()) {
		return true;
	}

	const requestUID = { correlationId: 'IMG-CDN-readiness', requestId: crypto.randomUUID() };

	try {
		const response = await fetch(config.imageCdnManifest, {
			headers: { 'x-correlation-id': requestUID.correlationId, 'x-request-id': requestUID.requestId },
			signal: AbortSignal.timeout(900),
		});
		return response.ok;
	} catch (e) {
		logError(requestUID, 'Image CDN readiness check failed', e, 503);
		return false;
	}
}

async function staticCdnReadiness() {
	if (!config.assetsManifest || !config.assetsPrefix) {
		return false;
	}

	const requestUID = { correlationId: 'Static-CDN-readiness', requestId: crypto.randomUUID() };

	try {
		const response = await fetch(config.assetsManifest, {
			headers: { 'x-correlation-id': requestUID.correlationId, 'x-request-id': requestUID.requestId },
			signal: AbortSignal.timeout(900),
		});
		return response.ok;
	} catch (e) {
		logError(requestUID, 'Static CDN readiness check failed', e, 503);
		return false;
	}
}

let isStaticCdnReady = false;
let isImageCdnReady = false;

export const initCdn = async () => {
	isStaticCdnReady = await staticCdnReadiness();
	isImageCdnReady = await imageCdnReadiness();
};

if (isSSR() && !import.meta.env.DEV) {
	setInterval(() => {
		staticCdnReadiness().then((status) => {
			isStaticCdnReady = status;
		});
		imageCdnReadiness().then((status) => {
			isImageCdnReady = status;
		});
	}, 1000);
}

const ASTRO_PATH_REGEX = /\/_astro\//g;
const replacementPath = config.assetsPrefix + 'astro/';

export function replaceStaticCdnUrl(html: string) {
	if (isStaticCdnReady) {
		return html.replace(ASTRO_PATH_REGEX, replacementPath);
	}
	return html;
}

const DOUBLE_SLASH_REGEX = /\/+/g;
export function getImageCdnRootPath(path: string = '') {
	if (isImageCdnReady) {
		return config.imageCdnUrl + path.replace(DOUBLE_SLASH_REGEX, '/');
	}
	return path;
}
